import { AlertTriangle, ArrowDownRight, ArrowUpRight } from "lucide-react";
import { money, num, pct } from "../../lib/format";

const KPI = [
  ["total_net_premium", "Toplam Net Prim", "money"], ["total_commission", "Toplam Komisyon", "money"],
  ["policy_count", "Poliçe Adedi", "num"], ["effective_commission_rate", "Efektif Komisyon Oranı", "pct"],
  ["top1_insurer_share", "En Büyük Şirket Payı", "pct"], ["top5_insurer_share", "Top 5 Şirket Payı", "pct"],
  ["top1_policy_group_share", "En Büyük Poliçe Grubu Payı", "pct"], ["top5_policy_group_share", "Top 5 Poliçe Grubu Payı", "pct"],
  ["top1_corporate_customer_share", "En Büyük Kurumsal Müşteri Payı", "pct"],
  ["top20_corporate_customer_share", "Top 20 Kurumsal Müşteri Payı", "pct"],
  ["top10_seller_share", "Top 10 Satıcı Payı", "pct"],
];

const format = (value, type) => type === "money" ? money(value, true) : type === "pct" ? pct(value, 2) : num(value);

export function MetricSwitch({ metric, setMetric }) {
  return <div className="portfolio-metric-switch" data-testid="portfolio-metric-switch">
    {[['net_premium','Net Prim'],['commission','Komisyon'],['policy_count','Poliçe Adedi']].map(([key, label]) =>
      <button key={key} data-testid={`metric-${key}-btn`} className={metric === key ? "active" : ""} onClick={() => setMetric(key)}>{label}</button>)}
  </div>;
}

export function PortfolioKpis({ data }) {
  const growth = data.kpis.growth;
  return <section className="portfolio-kpi-grid" data-testid="portfolio-kpi-grid">
    {KPI.map(([key, label, type]) => <div className="portfolio-kpi" data-testid={`kpi-${key.replaceAll('_','-')}`} key={key}>
      <span>{label}</span><strong>{format(data.kpis[key], type)}</strong>
      {key === "total_net_premium" && growth !== null && growth !== undefined && <small className={growth >= 0 ? "positive" : "negative"}>
        {growth >= 0 ? <ArrowUpRight size={12}/> : <ArrowDownRight size={12}/>} GY {pct(growth)}
      </small>}
    </div>)}
  </section>;
}

export function WarningBand({ warnings }) {
  return <section className="portfolio-warning-band" data-testid="concentration-warning-band">
    <div className="portfolio-warning-title"><AlertTriangle size={18}/><div><strong>Yoğunlaşma Uyarıları</strong><span>Eşikler yalnız uyarı üretir; hesaplamaları değiştirmez.</span></div></div>
    <div className="portfolio-warning-list">
      {warnings.length === 0 ? <span data-testid="warning-none" className="portfolio-warning-empty">Aktif eşik aşımı yok.</span> :
        warnings.map((item, index) => <div data-testid={`portfolio-warning-${index}`} className={`portfolio-warning ${item.severity}`} key={`${item.type}-${index}`}>
          <span>{item.message}</span><b>{pct(item.value)} / eşik {pct(item.threshold)}</b>
        </div>)}
    </div>
  </section>;
}